import type { FreezeChatRoomParams } from '@module/apis/client-side/chat/type';
import { useFreezeChatRoomMutation } from '@module/queries/chat/chatQueryHooks';
import useModalStore from '@module/stores/useModalStore';
import { BaseHttpResponseError } from '@module/utils/error/apiErrors';
import throttle from '@module/utils/throttle';
import { useRef } from 'react';

function useFreezeChat() {
  const { pushModal } = useModalStore();
  const handleError = (error: unknown) => {
    if (!(error instanceof BaseHttpResponseError)) return;
    pushModal({
      type: 'CONFIRM_MODAL',
      id: 'useFreezeChat',
      options: {
        description: error.serverResponse.message,
      },
    });
  };
  const { mutate: mutateFreezeChat } = useFreezeChatRoomMutation({
    onError: handleError,
  });
  const freezeChat = useRef(
    throttle((params: FreezeChatRoomParams) => {
      mutateFreezeChat(params);
    }, 500),
  );

  return {
    freezeChat: freezeChat.current,
  };
}

export default useFreezeChat;
